module.exports = __webpack_public_path__ + "static/media/Icons_Linkedin_white.059b0483.svg";